export const SOLVE_PROBLEM = 'SOLVE_PROBLEM';

export function solveProblem(annotationId, problemResponse, problemIds) {
  return {
    type: SOLVE_PROBLEM,
    payload: { annotationId, problemResponse, problemIds },
  };
}